<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "index",

  data() {
    return {};
  }
};
</script>

<style lang="css" scoped></style>
